import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      const next = loc.state?.from || (r.user.role === "admin" ? "/admin" : "/portal");
      nav(next, { replace: true });
    } else {
      setError(r.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="login-page">
      <form onSubmit={submit} className="w-full max-w-md card-dark p-8 space-y-5">
        <div>
          <div className="overline text-[var(--red)] mb-2">Welcome back</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Sign in</h1>
        </div>
        <div>
          <label className="overline mb-2 block">Email</label>
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" data-testid="login-email" />
        </div>
        <div>
          <label className="overline mb-2 block">Password</label>
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" data-testid="login-password" />
        </div>
        {error && <div className="text-sm text-[var(--red)]" data-testid="login-error">{error}</div>}
        <button type="submit" disabled={busy} className="btn-red w-full justify-center" data-testid="login-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
        </button>
        <div className="text-sm text-[var(--text-2)]">
          New here? <Link to="/register" className="link-red">Create an account</Link>
        </div>
        <div className="border-t border-[var(--border)] pt-5 text-sm text-[var(--text-2)]" data-testid="login-member-portal-note">
          Grant Partnership members should use the <Link to="/member" className="link-red">Member Portal</Link> with Google sign-in.
        </div>
      </form>
    </div>
  );
}
